<template>
  <div class="d-flex flex-column-reverse flex-lg-column">
    <div class="d-flex align-items-end flex-wrap flex-lg-nowrap gap-4 mb-3">
      <div class="form-field w-100">
        <span :id="`${_uid}-business-details-input`" class="caption">
          Business details
          <i class="fa-info-circle fal small ml-1" />
        </span>
        <input
          v-model.trim="filters.businessDetails"
          type="text"
          placeholder="All">
      </div>
      <b-popover
        placement='top'
        :target="`${_uid}-business-details-input`"
        custom-class='geogrids-popover'
        triggers='hover'>
        <div class='text-dark'>
          Name, Address, PlaceID, Store code
        </div>
      </b-popover>
      <div class="form-field w-100">
        <span class="caption">Search term</span>
        <input
          v-model.trim="filters.searchTerm"
          type="text"
          placeholder="All">
      </div>
      <div v-if="!options.noTags" class="form-field w-100">
        <span class="caption">Tags</span>
        <multiselect
          :options="allTags"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :searchable="true"
          :show-labels="false"
          :max-height="540"
          v-model="filters.selectedTags"
          placeholder="All">
          <template slot="selection" slot-scope="{ values, isOpen }">
            <span class="multiselect__single" v-if="values.length && !isOpen">
              {{ values.length }} tag{{ values.length !== 1 ? 's' : '' }} selected
            </span>
          </template>
        </multiselect>
      </div>
      <div class="form-field w-100">
        <span class="caption">Grid size</span>
        <multiselect
          v-model="filters.gridSize"
          :options="gridSizeFilterOptions"
          :multiple="false"
          :show-labels="false"
          :searchable="false"
          :max-height="540"
          placeholder="All">
          <template slot="singleLabel" slot-scope="{ option }">
            {{ option ? `${option}x${option}` : "All" }}
          </template>
          <template slot="option" slot-scope="{ option }">
            {{ option ? `${option}x${option}` : "All" }}
          </template>
        </multiselect>
      </div>
      <div v-if="!options.noShowDeleted" class="form-field w-100">
        <span class="caption">States</span>
        <multiselect
          @input='updateStateInFilter'
          v-model="specialState"
          :options="specialStates"
          :multiple="false"
          :show-labels="false"
          :searchable="false"
          :max-height="540"
          track-by='value'
          label='title'
          placeholder="All" />
      </div>
      <div class="form-field w-auto">
        <span>&nbsp;</span>
        <button :class="['btn btn-link mb-3 gap-2', { 'text-muted': isFilterCleared }]"
          :disabled="isFilterCleared"
          @click.prevent.stop="clearFilters">
          <i class="fas fa-eraser" />
          Clear filters
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

const INITIAL_FILTERS = {
  businessDetails: '',
  searchTerm: '',
  selectedTags: null,
  gridSize: null,
  state: null
}

export default {
  components: { Multiselect },
  props: {
    allTags: { type: Array, default: () => ([]) },
    gridSizeFilterOptions: { type: Array, required: true },
    options: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      filters: { ...INITIAL_FILTERS },
      specialStates: [
        { value: 'deleted', title: 'Deleted' },
        { value: 'firstTop3', title: 'TOP-3 first time' },
        { value: 'anyTop3', title: 'TOP-3 any time' }
      ],
      specialState: null
    }
  },
  computed: {
    isFilterCleared() {
      return !Object.values(this.filters).find((val) => val)
    }
  },
  methods: {
    clearFilters() {
      this.filters = { ...INITIAL_FILTERS }
      this.specialState = null
    },
    updateStateInFilter(val) {
      if (val) this.filters.state = val.value
      else this.filters.state = null
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        if (this.filterTimeout) clearTimeout(this.filterTimeout)

        this.filterTimeout = setTimeout(() => {
          this.$emit('filterChanged', this.filters)
        }, 500)
      }
    }
  }
}
</script>
